/* Pipli festive FX loader (Diwali edition).
   - Countdowns: any [data-pfx-count][data-target] ticks its [data-u="d|h|m|s"] children.
   - Scenes: any [data-pfx="banner|footer|panel"] mounts the three.js ambient scene once it is within
     250px of the viewport, only after window load + idle, so festive motion never competes with LCP.
     The shared three.js core (pipli-fx-core.js) downloads once and is cached across pages.
   - Burst: every successful AJAX add-to-cart throws gold sparks + marigold petals from the pressed button.
   No WebGL on Save-Data / 2G / no-WebGL devices (CSS fallbacks stay); reduced-motion gets still frames and no burst.
   URLs come from window.PFX_CFG = { core, ambient, burst } printed by layout/theme.liquid. */
(function () {
  var W = window, D = document, cfg = W.PFX_CFG;
  if (!cfg || !cfg.load || W.__pfxLoader) return;
  W.__pfxLoader = 1;

  /* ---------------- countdowns */
  var pad = function (n) { return (n < 10 ? '0' : '') + n; };
  function initCount(box) {
    var target = Date.parse(box.getAttribute('data-target'));
    if (isNaN(target)) { box.hidden = true; return; }
    var units = {};
    Array.prototype.forEach.call(box.querySelectorAll('[data-u]'), function (el) { units[el.getAttribute('data-u')] = el; });
    var after = box.getAttribute('data-after');
    (function tick() {
      var ms = target - Date.now();
      if (ms <= 0) {
        if (after && ms > -3 * 864e5) { box.textContent = after; box.hidden = false; box.classList.add('is-after'); }
        else { box.hidden = true; }
        return;
      }
      var s = Math.floor(ms / 1000);
      if (units.d) units.d.textContent = Math.floor(s / 86400);
      if (units.h) units.h.textContent = pad(Math.floor(s % 86400 / 3600));
      if (units.m) units.m.textContent = pad(Math.floor(s % 3600 / 60));
      if (units.s) units.s.textContent = pad(s % 60);
      box.hidden = false;
      setTimeout(tick, units.s ? 1000 - (Date.now() % 1000) : 30000);
    })();
  }
  function initCounts(scope) { Array.prototype.forEach.call((scope || D).querySelectorAll('[data-pfx-count]:not([data-pfx-ok])'), function (b) { b.setAttribute('data-pfx-ok', ''); initCount(b); }); }
  initCounts();

  /* ---------------- capability (checked lazily, once) */
  var conn = navigator.connection || {};
  var reduce = !!(W.matchMedia && W.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var lite = !!(conn.saveData || /(^|-)2g$/.test(conn.effectiveType || ''));
  var glOk = null;
  function canGL() {
    if (glOk !== null) return glOk;
    glOk = false;
    if (lite) return glOk;
    try {
      var c = D.createElement('canvas');
      var ctx = c.getContext('webgl2') || c.getContext('webgl');
      glOk = !!ctx;
      var lc = ctx && ctx.getExtension('WEBGL_lose_context');
      if (lc) lc.loseContext();
    } catch (e) { glOk = false; }
    D.documentElement.classList.add(glOk ? 'pfx-gl' : 'pfx-nogl');
    return glOk;
  }

  var coreP = null, mods = {};
  /* cfg.load is an inline import() wrapper: Shopify's asset minifier turns import() inside .js assets into require() */
  function core() { return coreP || (coreP = cfg.load(cfg.core)); }
  function mod(n) { return mods[n] || (mods[n] = cfg.load(cfg[n])); }
  function idle(fn, t) { (W.requestIdleCallback || function (f) { return setTimeout(f, 200); })(fn, { timeout: t || 1500 }); }
  /* after window load AND the first paint (pfxAfterPaint lives inline in theme.liquid's head), then idle */
  function afterLoad(fn) {
    var g = function () { (W.pfxAfterPaint || function (f) { f(); })(function () { idle(fn); }); };
    if (D.readyState === 'complete') g(); else W.addEventListener('load', g, { once: true });
  }

  /* ---------------- ambient scenes */
  function mountEl(el) {
    var data = {};
    var js = el.querySelector('script[type="application/json"]');
    if (js) { try { data = JSON.parse(js.textContent); } catch (e) {} }
    data.mode = data.mode || el.getAttribute('data-pfx');
    Promise.all([core(), mod('ambient')]).then(function (m) { m[1].mount(el, data, m[0]); })
      .catch(function (e) { el.classList.add('no-gl'); if (W.console) console.warn('pipli fx', e); });
  }
  afterLoad(function () {
    var els = D.querySelectorAll('[data-pfx]');
    if (!canGL()) { Array.prototype.forEach.call(els, function (el) { el.classList.add('no-gl'); }); return; }
    if (!('IntersectionObserver' in W)) return;
    var io = new IntersectionObserver(function (ents) {
      ents.forEach(function (e) { if (e.isIntersecting) { io.unobserve(e.target); mountEl(e.target); } });
    }, { rootMargin: '250px 0px' });
    Array.prototype.forEach.call(els, function (el) { io.observe(el); });
    // warm the burst on pages that can add to cart, so the first add celebrates instantly
    if (cfg.burst && !reduce && D.querySelector('[data-ppd-add], .ppf-card__add, form[action*="/cart/add"]')) idle(function () { core(); mod('burst'); }, 5000);
  });

  /* ---------------- add-to-cart burst */
  var lastPt = null;
  D.addEventListener('pointerdown', function (e) {
    var b = e.target && e.target.closest && e.target.closest('button, [type="submit"], [role="button"]');
    if (b) lastPt = { el: b, t: Date.now(), x: e.clientX, y: e.clientY };
  }, true);
  function fire() {
    if (!cfg.burst || reduce || !canGL()) return;
    var p = lastPt && Date.now() - lastPt.t < 10000 ? lastPt : null;
    var x = W.innerWidth / 2, y = W.innerHeight * 0.62;
    if (p) {
      var r = p.el && p.el.isConnected ? p.el.getBoundingClientRect() : null;
      if (r && r.width && r.bottom > 0 && r.top < W.innerHeight) { x = r.left + r.width / 2; y = r.top + r.height * 0.3; }
      else { x = p.x; y = p.y; }
    }
    Promise.all([core(), mod('burst')]).then(function (m) { m[1].burst(m[0], x, y); }).catch(function () {});
  }
  if (typeof W.fetch === 'function') {
    var origFetch = W.fetch;
    W.fetch = function (input) {
      var pr = origFetch.apply(this, arguments);
      try {
        var url = typeof input === 'string' ? input : ((input && input.url) || '');
        if (url.indexOf('/cart/add') !== -1) {
          pr.then(function (res) { if (res && res.ok) D.dispatchEvent(new CustomEvent('pipli:cart-added')); }, function () {});
        }
      } catch (e) {}
      return pr;
    };
  }
  D.addEventListener('pipli:cart-added', fire);
  W.PipliFX = { fire: fire, initCounts: initCounts };
})();
